module.exports = __webpack_public_path__ + "static/media/icn-insight.99dd7acb.svg";